import user from "./user";
import promote from "./promote";
import enterprise from "./enterprise";

/**
 * 华博特项目接口文档
 */
export default {
  user,
  promote,
  enterprise,
};
